module.exports = __webpack_public_path__ + "img/c06_unitwarchariot_Normal_ua.4a2f280d.webp";